export interface BuildingControlProjectsType {
    project_id: number;
    job_number: string;
    project_type: string;
    description: string | null;
    status: string;
    user_id: number;
    address: string;
    post_code: string;
    is_building_control_project_list: boolean;
}

// to single object maping
export const mapBuildingControlProjectsType = (data: any): BuildingControlProjectsType => {
    if (!data) {
        throw new Error("Invalid Projects");
    }

    const project: BuildingControlProjectsType = {
        project_id: data.project_id,
        job_number: data.job_number,
        project_type: data.project_type,
        description: data.description,
        status: data.status,
        user_id: data.user_id,
        address: data.address,
        post_code: data.post_code,
        is_building_control_project_list: data.is_building_control_project_list,
    };

    return project;
};

// maping list objects
export const mapBuildingControlProjectsTypes = (data: any[]): BuildingControlProjectsType[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Projects");
    }

    return data.map(mapBuildingControlProjectsType);
};
